import { css } from 'styled-components'

export default css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
